import {Message} from 'element-ui';
import {v4 as uuidv4} from 'uuid';
export const handleCopy = (text) => {
  try {
    // 创建一个隐藏的 textarea 元素
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    // 选择 textarea 中的文本
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    Message.success('复制成功');
  } catch (err) {
    console.log('复制到剪切板失败:', err);
  }
};
// 本地存取
export const Storage = {
  set: function (key, value) {
    if (!key || !value) {
      return;
    }
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  },
  get: function (key) {
    var value = sessionStorage.getItem(key);
    if (!value) {
      return;
    }
    // 判断是否是JSON对象
    if (value[0] === '{') {
      value = JSON.parse(value);
    }
    return value;
  },

  remove: function (key) {
    if (!key) {
      return;
    }
    sessionStorage.removeItem(key);
  }
};

// 根据生日日期计算年龄
export function calculateAge(dateOfBirth) {
  const currentDate = new Date();
  const birthDate = new Date(dateOfBirth);
  const age = currentDate.getTime() - birthDate.getTime();
  const ageInYears = Math.floor(age / (365.25 * 24 * 60 * 60 * 1000));
  return ageInYears;
}

// 当内容为空时展示默认内容
export function showEmpty(val, defaultCon = '-') {
  if (val === 0) {
    return val;
  }

  if (val) {
    return val;
  } else {
    return defaultCon;
  }
}

// 将11位手机号的中间4位替换为*
export function maskPhoneNumber(phone) {
  // 先将输入转为字符串，统一处理
  const phoneStr = String(phone).trim();

  /* 1. 大陆常见号段 */
  const phoneReg = /^1[3-9]\d{9}$/;
  if (phoneReg.test(phoneStr)) {
    return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'); // 非有效手机号返回原值
  }

  /* 2. 港澳台及海外：仅含数字，长度 8~15 */
  if (/^\d{8,15}$/.test(phoneStr)) {
    const head = phoneStr.slice(0, 3);
    const tail = phoneStr.slice(-4);
    const maskLen = phoneStr.length - 7;
    return `${head}${'*'.repeat(maskLen)}${tail}`;
  }

  /* 3. 含字母或分机符号：提取连续数字再脱敏 */
  const digitOnly = phoneStr.replace(/\D/g, '');
  if (digitOnly.length >= 8 && digitOnly.length <= 15) {
    const head = digitOnly.slice(0, 3);
    const tail = digitOnly.slice(-4);
    const masked = `${head}****${tail}`;
    /* 把脱敏后的数字按原字符串中的位置放回去 */
    let idx = 0;
    return phoneStr.replace(/\d/g, () => {
      const ch = masked[idx];
      idx += 1;
      return ch;
    });
  }

  /* 4. 分离分机：遇到「转/ext/分机」后视为分机号 */
  if (phoneStr.includes('转') || phoneStr.includes('ext') || phoneStr.includes('分机')) {
    const [digitPart, , extPart = ''] = phoneStr.split(/(转|ext|分机)/i);
    const masked = digitPart.replace(/\d+/g, (m) => {
      const len = m.length;
      if (len < 8) {
        return m;
      }
      const head = m.slice(0, 3);
      const tail = m.slice(-4);
      const maskLen = len - 7;
      return `${head}${'*'.repeat(maskLen)}${tail}`;
    });
    return extPart ? `${masked}${RegExp.$1}${extPart}` : masked;
  }

  // 替换中间4位为*：保留前3位 + 4个* + 保留最后4位
  return phoneStr;
}

// 转换药品列表，并判断注意事项为空的情况
export function transDrugsList(drugsList = []) {
  return drugsList.map((res) => {
    return {
      ...res,
      considerations: res.considerations === '' ? '' : Number(res.considerations),
      diffId: uuidv4()
    };
  });
}

// 商品分类去除children为空数组的字段
export function transTreeToOptions(treeData) {
  return treeData.map((item) => {
    const {id, categoryName, parentId, children} = item;
    const option = {
      id,
      categoryName,
      parentId
    };

    if (children.length > 0) {
      option.children = transTreeToOptions(children);
    }
    return option;
  });
}

// 树形结构模糊搜索 - 只返回匹配的节点及其必要的祖先节点
export function treeFuzzySearch(treeData, keyword, options = {}) {
  const {fieldName = 'categoryName', caseSensitive = false} = options;

  if (!Array.isArray(treeData) || !keyword || keyword.trim() === '') {
    return [];
  }

  const searchKeyword = caseSensitive ? keyword.trim() : keyword.trim().toLowerCase();

  function isNodeMatch(node) {
    const fieldValue = node[fieldName];
    if (!fieldValue) {
      return false;
    }

    return caseSensitive ? fieldValue.includes(searchKeyword) : fieldValue.toLowerCase().includes(searchKeyword);
  }

  function filterNodes(nodes) {
    if (!Array.isArray(nodes) || nodes.length === 0) {
      return [];
    }
    const result = [];

    for (const node of nodes) {
      const clonedNode = JSON.parse(JSON.stringify(node));
      const currentMatch = isNodeMatch(clonedNode);

      // 递归处理子节点（只保留匹配的子节点）
      /* eslint-disable max-len */
      const filteredChildren = clonedNode.children && clonedNode.children.length > 0 ? filterNodes(clonedNode.children) : [];
      /* eslint-disable max-len */
      if (currentMatch || filteredChildren.length > 0) {
        if (currentMatch) {
          // 当前节点匹配
          if (filteredChildren.length > 0) {
            clonedNode.children = filteredChildren;
          } else {
            clonedNode.children = [];
          }
        } else {
          clonedNode.children = filteredChildren;
        }

        result.push(clonedNode);
      }
    }
    return result;
  }
  return filterNodes(treeData);
}
